module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/rectangleConversionS_CM.8ba69753.svg";